import React, { useEffect, useRef, useState } from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';

import { BackdropForDialog, SubmitButton } from 'components';
import { UserSettingsForm } from 'forms';
import { useAppDispatch, useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { updateLayout } from 'store/slices/layout.slice';

export const ProfileUserSettingsPage = () => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const between_md_1000 = useMediaQuery(theme.breakpoints.between('md', 1000));
  const dispatch = useAppDispatch();
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [loading_submit, setLoadingSubmit] = useState<boolean>(false);
  const { id: userId } = useAppSelector(selectCurrentUserInfo);
  const formRef = useRef<any>();
  const submitButtonLabel = down_sm ? 'Update' : 'Update Settings';

  useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'User Settings' }));
  }, []);

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <div>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        User Settings
      </Typography>

      <UserSettingsForm
        ref={formRef}
        isMobile={down_sm || between_md_1000}
        userId={userId}
        onInit={(loading) => setLoadingForm(loading)}
        onSubmitting={(loading) => setLoadingSubmit(loading)}
      />

      <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onSubmit} sx={{ marginTop: 6 }} />

      <BackdropForDialog loading={loading_form} />
    </div>
  );
};
